// components/menuItem/MenuItem.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../../../redux/features/cartState";
import ProcessingBar from "utils/Processingbar";

const NAV_DELAY_MS = 800; // tweak to taste

const MenuItemDirect = ({
  item,
  onClick,
  isSelected,
  operatorId,
  operatorType,
  operatorSlug,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleActionClick = (e) => {
    e.stopPropagation();
    if (loading) return; // prevent double click spam
    setLoading(true);

    if (operatorType === "booking") {
      // Show bar, then navigate to booking
      setTimeout(() => {
        navigate(`/operator/booking/${operatorSlug}`);
      }, NAV_DELAY_MS);
    } else {
      // Menu flow: add to cart, then navigate after small delay
      dispatch(addToCart({ item: { ...item, count: 1 } }));
      setTimeout(() => {
        navigate(`/operator/menu/${operatorSlug}`);
      }, NAV_DELAY_MS);
    }
  };

  return (
    <div
      onClick={onClick}
      className={`relative w-full flex justify-between items-center gap-4 p-4 border border-border rounded-lg transition-all cursor-pointer

         border-border hover:bg-gray-200 dark:bg-neutral-800
        }`}
    >
      <div className="flex-1 sm:pr-4">
        <p className={`text-base sm:text-md font-semibold`}>{item.title}</p>
        <p
          className={`text-sm  
           text-textGray   `}
        >
          {item.desc || " "}
        </p>
        <p className="text-base text-text text-sm mt-1">
          ${item.price}
          {item.discount && (
            <span className="text-green-600 text-sm font-semibold ml-2">
              Save {item.discount}
            </span>
          )}
        </p>
      </div>

      <div className="w-[110px]">
        {loading ? (
          <div className="py-1">
            <ProcessingBar />
          </div>
        ) : (
          <button
            type="button"
            className="w-full border border-border px-3 py-2 bg-border rounded-xl text-sm hover:opacity-90 active:scale-[0.98]"
            onClick={handleActionClick}
          >
            {operatorType === "booking" ? "Book" : "Order"}
          </button>
        )}
      </div>
    </div>
  );
};

export default MenuItemDirect;
